import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { Link } from 'react-router-dom';

export default function Contact() {
  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    const params = new URLSearchParams();
    formData.forEach((value, key) => {
      params.append(key, value.toString());
    });
    fetch('https://readdy.ai/api/form/d8q0970n4gr6p3b2g2vg', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: params.toString(),
    })
      .then(() => {
        const el = document.getElementById('contact-success');
        if (el) el.style.display = 'block';
        form.reset();
      })
      .catch(() => {
        const el = document.getElementById('contact-error');
        if (el) el.style.display = 'block';
      });
  };

  return (
    <>
      <Navbar />
      <main>
        <script type="application/ld+json">{JSON.stringify({"@context":"https://schema.org","@type":"BreadcrumbList","itemListElement":[{"@type":"ListItem","position":1,"name":"Home","item":"https://sugargoospreadsheet.work/"},{"@type":"ListItem","position":2,"name":"Contact"}]})}</script>
        <script type="application/ld+json">{JSON.stringify({"@context":"https://schema.org","@type":"ContactPage","name":"Contact Sugargoo Spreadsheet","description":"Get in touch with the Sugargoo Spreadsheet team. Send us your questions, feedback, or product suggestions.","url":"https://sugargoospreadsheet.work/contact"})}</script>
        <article>
          <header className="w-full pt-24 md:pt-32 pb-12 md:pb-16 bg-background-50">
            <div className="max-w-[900px] mx-auto px-4 md:px-6 lg:px-10">
              <div className="flex items-center gap-2 text-xs text-foreground-500 mb-4">
                <Link to="/" className="hover:text-primary-600 transition-colors cursor-pointer">Home</Link>
                <i className="ri-arrow-right-s-line"></i>
                <span>Contact</span>
              </div>
              <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-extrabold text-foreground-950 leading-tight">Contact Us</h1>
              <p className="mt-4 text-base md:text-lg text-foreground-600 leading-relaxed max-w-2xl">Have questions about the Sugargoo Spreadsheet? Want to share a product find? We would love to hear from you — drop us a message below.</p>
            </div>
          </header>

          <div className="max-w-[900px] mx-auto px-4 md:px-6 lg:px-10 py-10 md:py-14">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16">
              <div>
                <h2 className="font-heading text-xl font-bold text-foreground-950 mb-5">Send Us a Message</h2>
                <form data-readdy-form="" id="contact-form" onSubmit={handleSubmit} className="space-y-5">
                  <div>
                    <label htmlFor="name" className="block text-sm font-semibold text-foreground-900 mb-1.5">Your Name</label>
                    <input type="text" id="name" name="name" required className="w-full px-4 py-3 text-sm bg-background-100 border border-background-200/70 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-400 focus:border-transparent transition-all text-foreground-900" placeholder="Enter your name" />
                  </div>
                  <div>
                    <label htmlFor="email" className="block text-sm font-semibold text-foreground-900 mb-1.5">Email Address</label>
                    <input type="email" id="email" name="email" required className="w-full px-4 py-3 text-sm bg-background-100 border border-background-200/70 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-400 focus:border-transparent transition-all text-foreground-900" placeholder="you@example.com" />
                  </div>
                  <div>
                    <label htmlFor="subject" className="block text-sm font-semibold text-foreground-900 mb-1.5">Subject</label>
                    <select id="subject" name="subject" required className="w-full px-4 py-3 text-sm bg-background-100 border border-background-200/70 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-400 focus:border-transparent transition-all text-foreground-900 cursor-pointer">
                      <option value="">Select a topic</option>
                      <option value="general">General Inquiry</option>
                      <option value="product">Product Suggestion</option>
                      <option value="broken-link">Report Broken Link</option>
                      <option value="partnership">Partnership</option>
                      <option value="other">Other</option>
                    </select>
                  </div>
                  <div>
                    <label htmlFor="message" className="block text-sm font-semibold text-foreground-900 mb-1.5">Message</label>
                    <textarea id="message" name="message" required maxLength={500} rows={5} className="w-full px-4 py-3 text-sm bg-background-100 border border-background-200/70 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-400 focus:border-transparent transition-all text-foreground-900 resize-none" placeholder="Type your message here (max 500 characters)"></textarea>
                    <p className="text-xs text-foreground-400 mt-1">Maximum 500 characters</p>
                  </div>
                  <button type="submit" className="w-full sm:w-auto px-8 py-3.5 bg-accent-500 text-white font-semibold text-sm rounded-full hover:bg-accent-600 transition-all whitespace-nowrap cursor-pointer">
                    Send Message <i className="ri-send-plane-line ml-1.5"></i>
                  </button>
                  <div id="contact-success" style={{display: 'none'}} className="p-4 bg-primary-100 text-primary-800 text-sm rounded-lg font-medium">
                    Message sent successfully! We will get back to you soon.
                  </div>
                  <div id="contact-error" style={{display: 'none'}} className="p-4 bg-red-50 text-red-800 text-sm rounded-lg font-medium">
                    Something went wrong. Please try again or email us directly.
                  </div>
                </form>
              </div>

              <div>
                <h2 className="font-heading text-xl font-bold text-foreground-950 mb-5">Other Ways to Reach Us</h2>
                <div className="space-y-5">
                  <div className="bg-background-100 rounded-xl p-5">
                    <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center mb-3">
                      <i className="ri-mail-line text-primary-600 text-lg"></i>
                    </div>
                    <h3 className="font-heading text-sm font-bold text-foreground-950 mb-1">Email</h3>
                    <p className="text-sm text-foreground-600">info@sugargoospreadsheet.work</p>
                  </div>
                  <div className="bg-background-100 rounded-xl p-5">
                    <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center mb-3">
                      <i className="ri-links-line text-primary-600 text-lg"></i>
                    </div>
                    <h3 className="font-heading text-sm font-bold text-foreground-950 mb-1">Main Platform</h3>
                    <a href="https://kaspreadsheet.com/" target="_blank" rel="noopener nofollow" className="text-sm text-primary-600 hover:text-primary-700 font-medium cursor-pointer">kaspreadsheet.com</a>
                  </div>
                  <div className="bg-background-100 rounded-xl p-5">
                    <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center mb-3">
                      <i className="ri-information-line text-primary-600 text-lg"></i>
                    </div>
                    <h3 className="font-heading text-sm font-bold text-foreground-950 mb-1">Response Time</h3>
                    <p className="text-sm text-foreground-600">We typically respond within 24-48 hours on business days.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </article>
      </main>
      <Footer />
    </>
  );
}